export default __webpack_public_path__ + "static/media/Entregado.988fb968.svg";